import { Stack } from "expo-router";
import Head from "expo-router/head";

import { AdminShell } from "../../components/admin/AdminShell";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { PortalGate } from "../../lib/PortalGate";
import { PANE_THEMES } from "../../components/brand/paneThemes";

const THEME = PANE_THEMES.Admin;
const BLACK = THEME.pageBg;

export default function AdminLayout() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <PortalGate portal="admin">
        <AdminShell>
          <ErrorBoundary boundaryName="admin">
            <Stack
              screenOptions={{
                headerShown: false,
                contentStyle: { backgroundColor: BLACK },
                animation: "none",
              }}
            />
          </ErrorBoundary>
        </AdminShell>
      </PortalGate>
    </>
  );
}
